import { defineStore } from "pinia";
import Services from '@/services/sutting/issuersResidentialCardsServices'
import { mapList, mapIssuerResidentialCard } from '@/helpers/mapFuncs'

export const useIssuersResidentialCardsStore = defineStore("issuersResidentialCards", {
persist: true,
state:()=>({
    issuerResidentialCard: {},
    issuersResidentialCards: [],
}),
getters : {
    getIssuerResidentialCard() {
        return mapIssuerResidentialCard(this.issuerResidentialCard)
    },
    getIssuersResidentialCards() {
        return this.issuersResidentialCards.map(mapIssuerResidentialCard)
    },
    getIssuersResidentialCardsList() {
        return this.issuersResidentialCards.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setIssuerResidentialCard(issuerResidentialCard) {
        this.issuerResidentialCard = issuerResidentialCard
    },
    setIssuersResidentialCards(issuersResidentialCards) {
        this.issuersResidentialCards = issuersResidentialCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setIssuerResidentialCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setIssuersResidentialCards(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.issuersResidentialCards.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.issuersResidentialCards[this.issuersResidentialCards.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.issuersResidentialCards = this.issuersResidentialCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
